<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        title="面接情報掲出メニュー"
      />
      <interview-jobs :jobs="jobs" />
      <interview-countermeasures
        :interview-countermeasures="interviewCountermeasures"
        @fetchInterviewCountermeasures="fetchInterviewCountermeasures"
      />
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import InterviewJobs from '@/components/organisms/InterviewJobs'
import InterviewCountermeasures from '@/components/organisms/InterviewCountermeasures'

export default {
  components: {
    SettingHeader,
    InterviewJobs,
    InterviewCountermeasures
  },
  data () {
    return {
      jobs: [],
      interviewCountermeasures: []
    }
  },
  created () {
    this.fetchJobInterviewCountermeasures()
    this.fetchInterviewCountermeasures()
  },
  methods: {
    fetchJobInterviewCountermeasures () {
      this.$http.secured.get('/jobs/_interview_countermeasures').then(response => this.$set(this, 'jobs', response.data))
    },
    fetchInterviewCountermeasures () {
      this.$http.secured.get('/interview_countermeasures').then(response => this.$set(this, 'interviewCountermeasures', response.data))
    }
  }
}
</script>
